import React from 'react';
import { Table, Tooltip, Typography } from 'antd';
import tipo1 from '../../images/tipo1.svg';
import tipo2 from '../../images/tipo2.svg';
import tipo3 from '../../images/tipo3.svg';
import tipo4 from '../../images/tipo4.svg';

const { Text } = Typography;
interface Props {
  t: any,
  purcheseInfo: {
    activatedLicenses: number,
    purchasedLicenses: number,
    purchasedSensors: number,
    shippedSensors: number,
    type: number,
  }[],
}

export const SensorsTable = ({ t, purcheseInfo }: Props) => {
  const dataSource = purcheseInfo.map((item: any) => {
    return {
      key: item.type,
      sensorType: `${t('TYPE')} ${item.type}`,
      activeLicense: item.activatedLicenses,
      purchasedSensors: item.purchasedSensors,
      purcheseLicense: item.purchasedLicenses,
      shipped: item.shippedSensors,
      url: item.type === 1 ? tipo1 : item.type === 2 ? tipo2 : item.type === 3 ? tipo3 : item.type === 4 ? tipo4 : ''
    };
  });

  const columns = [
    {
      title: `${t('SENSOR_TYPE')}`,
      dataIndex: 'sensorType',
      key: 'type',
      // eslint-disable-next-line react/display-name
      render: (text: any, record: any) => {
        return (
          <div>
            <Tooltip title={record.sensorType}>
              <img alt={record.sensorType} src={record.url} />
            </Tooltip>
          </div>
        );
      }
    },
    {
      title: `${t('ACTIVE_LICENSE')}`,
      dataIndex: 'activeLicense',
      key: 'activeLicense'
    },
    {
      title: `${t('PURCHASED_SENSORS')}`,
      dataIndex: 'purchasedSensors',
      key: 'sold'
    },
    {
      title: `${t('SHIPPEND_SENSORS')}`,
      dataIndex: 'shipped',
      key: 'shipped'
    },
    {
      title: `${t('NUMBER_LICENSE')}`,
      dataIndex: 'purcheseLicense',
      key: 'purcheseLicense'
    }
  ];

  return (<><div className='titleBox'>
    <Text className='titleBlackBox' >{`${t('PURCHASE_INFO')}`}</Text>

  </div>
    <div className='boxActiveSensors'>
      <Table size='small' pagination={false} dataSource={dataSource} columns={columns} />
    </div></>);
};